import React from 'react';
import ReactDOM from 'react-dom';

import ThemeProvider from 'react-toolbox/lib/ThemeProvider';
import App from './App';

import './index.css';
// import App from './App';
import registerServiceWorker from './registerServiceWorker';
import theme from './assets/react-toolbox/theme';
import './assets/react-toolbox/theme.css';

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>,
  document.getElementById('root'),
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js